import React, { Component } from 'react'
import { connect } from 'react-redux'
const deepEqual = require('deep-equal');

/*****
Conditional component: Allow to show content in function of store data.
usage : 
	<Conditionnal CONDITION ARGS > [CONTENT TO LOCK SHOW IF CONDITION OK] </Conditionnal>

Arguments :
linked_data_id ---> Questions to check on store. 
- isNotEmpty
- isEmpty
- isEqualTo (targetDataValueCompare required)
- isNotEqualTo (targetDataValueCompare required)
- targetDataValueCompare  ---> value to compare


/!\ attention, un INT 0 sera vu comme un undefined, a checker pourquoi 
***/

class Conditionnal extends Component {
    render() {
        var Valid = false
        var content
        // if is empty
        if (this.props.isEmpty) {
            if (this.props.targetDataValue === undefined) {
                Valid = true
            } else if (
                Array.isArray(this.props.targetDataValue) &&
                this.props.targetDataValue.length === 0
            ) {
                Valid = true
            }
        }

        // if not empty
        else if (this.props.isNotEmpty) {
            if (this.props.targetDataValue !== undefined) {
                if (Array.isArray(this.props.targetDataValue)) {
                    if (this.props.targetDataValue.length !== 0) {
                        Valid = true
                    }
                } else {
                    Valid = true
                }
            }
        }

        //Is equal to
        else if (this.props.isEqualTo) {
            // if is egal
            if (
                this.props.targetDataValue !== undefined &&
                this.props.targetDataValue === this.props.targetDataValueCompare
            ) {
                Valid = true
            }

            // if contains
            if (
                Array.isArray(this.props.targetDataValue) &&
                this.props.targetDataValue.includes(
                    this.props.targetDataValueCompare
                )
            ) {
                Valid = true
            }

            if (
                typeof this.props.targetDataValue === 'object' &&
                this.props.targetDataValue !== null &&
                deepEqual(this.props.targetDataValue, this.props.targetDataValueCompare)
            ) {
                Valid = true;
            }
        }

        //Is not equal to
        else if (this.props.isNotEqualTo) {
            // if target value is undefined -> is not egal true
            if (this.props.targetDataValue === undefined) {
                Valid = true
            }

            // if is not egal
            if (
                typeof this.props.targetDataValue !== 'object' &&
                this.props.targetDataValue !== this.props.targetDataValueCompare
            ) {
                Valid = true
            }

            // if not contain
            if (
                Array.isArray(this.props.targetDataValue) &&
                !this.props.targetDataValue.includes(
                    this.props.targetDataValueCompare
                )
            ) {
                Valid = true
            }

            if (
                typeof this.props.targetDataValue === 'object' &&
                this.props.targetDataValue !== null &&
                !deepEqual(this.props.targetDataValue, this.props.targetDataValueCompare)
            ) {
                Valid = true;
            }
        }


        else if (this.props.isIn) {

            // if contains
            if (
                this.props.targetDataValueCompare.includes(
                    this.props.targetDataValue
                )
            ) {
                Valid = true
            }

        }

        else if (this.props.isNotIn) {

            // if doesn't contain
            if (
                !this.props.targetDataValueCompare.includes(
                    this.props.targetDataValue
                )
            ) {
                Valid = true
            }

        }

        if (Valid) {
            content = <div>{this.props.children}</div>
        }
        return <div>{content}</div>
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        targetDataValue: state.answer[ownProps.linked_data_id],
    }
}

export default connect(mapStateToProps)(Conditionnal)
